/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { useIsOpen } from 'integration/hooks/useIsOpen';
import { parseHTML } from '@/utils/parseHTML';
import { useSingleSettings } from '@/data/Settings';
import { formatPrice } from '@/utils/formatPrice';
import { DEFAULT_SHIPPING_MIN } from '@/components/content/Cart/parts/OrderProgressShippingCost';
import { useMemo } from 'react';

export const IsFullOfferCartAlert: FC = () => {
	const showMore = useIsOpen();
	const { settings } = useSingleSettings();

	const defaultShippingMin = useMemo<number>(
		() => settings?.userData['com.monto.minimo.eg'] ?? DEFAULT_SHIPPING_MIN,
		[settings]
	);

	return (
		<Box
			id="extended-zone-shipping"
			sx={{
				backgroundColor: '#EFF6FF',
				border: '1px solid #DBEAFE',
				color: '#0A1D85',
				padding: '8px',
				fontSize: '11px',
				fontWeight: '400',
				borderRadius: '4px',
				cursor: 'pointer',

				display: 'flex',
				flexDirection: 'row',

				alignItems: showMore.open ? 'flex-start' : 'center',
			}}
			onClick={showMore.toggle}
		>
			<LocalShippingIcon
				sx={{
					color: '#0A1D85',
					fontSize: 'inherit',
					mt: showMore.open ? { xs: '3px', md: '2px' } : 0,
					mr: 0.5,
				}}
			/>
			<Typography component="span">
				{'Esta compra no incluye Envío gratís.'}{' '}
				{showMore.open ? (
					<Typography component="span" sx={{ cursor: 'pointer' }}>
						{parseHTML(
							`El <strong>Envío gratís</strong> aplica únicamente en <strong>productos sin descuento</strong> desde <strong>${formatPrice(
								'es-MX',
								'MXN',
								defaultShippingMin
							).replace('.00', '')}</strong>.`
						)}
					</Typography>
				) : (
					<Typography
						component="span"
						sx={{ color: '#0A1D85', fontWeight: '600', cursor: 'pointer' }}
					>
						Saber más
					</Typography>
				)}
			</Typography>
		</Box>
	);
};
